<script>
  'use strict'

  import { Bubble, mixins } from 'vue-chartjs'

  const { reactiveProp } = mixins

  export default {
    extends: Bubble,

    mixins: [reactiveProp],

    props: ['chartData', 'options'],

    mounted () {
      this.renderChart(this.chartData, this.options)
    },

    watch: {
      options: {
        handler: function (newVal, oldVal) {
          this.renderChart(this.chartData, this.options)
        },
        deep: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/vue-chart/charts/bubble.vue